import { render, staticRenderFns } from "./emailtemplatecard.vue?vue&type=template&id=584926ce&lang=pug"
import script from "./emailtemplatecard.vue?vue&type=script&lang=js"
export * from "./emailtemplatecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports